"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTheme = exports.ThemeProvider = exports.theming = void 0;
var react_1 = require("react");
var react_jss_1 = require("react-jss");
var ThemeContext = react_1.createContext({});
exports.theming = react_jss_1.createTheming(ThemeContext);
exports.ThemeProvider = exports.theming.ThemeProvider, exports.useTheme = exports.theming.useTheme;
